import React, { useEffect, useState } from "react";
import { Nav } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { empleadosService } from "../services/api";
import {
  FaUsers,
  FaTruck,
  FaTags,
  FaSignOutAlt,
  FaUser,
  FaBars,
  FaTimes,
  FaChevronDown,
  FaChevronRight,
  FaCar,
  FaBuilding,
  FaTachometerAlt,
  FaFileAlt,
} from "react-icons/fa";

export const SidebarToggleButton = ({ onClick }) => (
  <button
    className="sidebar-toggle-btn d-md-none"
    onClick={onClick}
    aria-label="Abrir menú"
    style={{
      position: "fixed",
      top: 16,
      left: 16,
      zIndex: 1201,
      background: "#343a40",
      color: "#fff",
      border: "none",
      borderRadius: "50%",
      width: 44,
      height: 44,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    }}
  >
    <FaBars size={22} />
  </button>
);

const Sidebar = ({ show, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout, isAdmin } = useAuth();
  const [transportesOpen, setTransportesOpen] = useState(false);
  const [documentsAlertCount, setDocumentsAlertCount] = useState(0);

  const loadDocumentsAlertCount = async () => {
    const baseParams = {
      search: "",
      page: 1,
      limit: 1,
      orderBy: 0,
      statusFilter: "-1",
      selectedRelacionesLaborales: [],
      selectedDocuments: [],
      selectedDepartamento: "-1",
      activoFilter: "-1",
    };
    try {
      const [caducadosRes, proximosRes] = await Promise.all([
        empleadosService.getDocumentosCentralizados({
          ...baseParams,
          documentStatusFilter: "4",
        }),
        empleadosService.getDocumentosCentralizados({
          ...baseParams,
          documentStatusFilter: "3",
        }),
      ]);
      const totalCaducados = caducadosRes.data?.pagination?.total ?? 0;
      const totalProximos = proximosRes.data?.pagination?.total ?? 0;
      setDocumentsAlertCount(totalCaducados + totalProximos);
    } catch (error) {
      setDocumentsAlertCount(0);
    }
  };

  useEffect(() => {
    if (!isAdmin) return;
    loadDocumentsAlertCount();
  }, [isAdmin]);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const menuItems = [
    {
      path: "/dashboard",
      label: "Dashboard",
      icon: <FaTachometerAlt />,
      show: isAdmin,
    },
    {
      path: "/empleados",
      label: "Empleados",
      icon: <FaUsers />,
      show: isAdmin,
    },
    {
      path: "/tipos",
      label: "Tipos",
      icon: <FaTags />,
      show: isAdmin,
    },
    {
      path: "/documentacion",
      label: "Documentación",
      icon: <FaFileAlt />,
      show: isAdmin,
    },
    {
      path: "/empresa",
      label: "Empresa",
      icon: <FaBuilding />,
      show: isAdmin,
    },
  ];

  return (
    <div
      className={`sidebar p-3${show ? " sidebar-mobile-open" : ""}`}
      style={{
        position: "fixed",
        top: 0,
        left: show ? 0 : "-100vw",
        width: "80vw",
        maxWidth: 300,
        height: "100vh",
        background: "#343a40",
        zIndex: 1200,
        transition: "left 0.3s cubic-bezier(.4,0,.2,1)",
        boxShadow: show ? "2px 0 8px rgba(0,0,0,0.15)" : "none",
        display: "block",
      }}
    >
      <div className="d-flex justify-content-between align-items-center mb-3">
        <img
          src="https://www.visualmax.net/wp-content/themes/yootheme/cache/75/LOGO-VISUALMAX-BLANCO-754f3b94.webp"
          alt="Visualmax"
          style={{ width: 160 }}
        />
        <button
          className="d-md-none"
          onClick={onClose}
          aria-label="Cerrar menú"
          style={{
            background: "none",
            border: "none",
            color: "#fff",
            fontSize: 28,
          }}
        >
          <FaTimes />
        </button>
      </div>
      <div className="mb-4">
        <div className="text-white" style={{ fontWeight: 600 }}>
          {user?.nombre || ""}
        </div>
        {user?.rol && (
          <small className="text-muted">{user.rol}</small>
        )}
      </div>
      <Nav className="flex-column">
        {menuItems.map((item) => {
          let isActive = false;
          if (item.path === "/dashboard") {
            isActive = location.pathname === "/dashboard";
          } else if (item.path === "/empleados") {
            isActive = location.pathname.startsWith("/empleados");
          } else if (item.path === "/tipos") {
            isActive = location.pathname.startsWith("/tipos");
          } else if (item.path === "/documentacion") {
            isActive = location.pathname.startsWith("/documentacion");
          } else if (item.path === "/empresa") {
            isActive = location.pathname.startsWith("/empresa");
          } else {
            isActive = location.pathname === item.path;
          }
          return (
            item.show && (
              <Nav.Link
                key={item.path}
                href={item.path}
                className={isActive ? "active" : ""}
                onClick={(e) => {
                  e.preventDefault();
                  navigate(item.path);
                  if (onClose) onClose();
                }}
              >
                {item.icon} {item.label}
                {item.path === "/documentacion" && documentsAlertCount > 0 && (
                  <span
                    style={{
                      float: "right",
                      background: "#dc3545",
                      color: "#fff",
                      borderRadius: 999,
                      fontSize: 12,
                      padding: "2px 8px",
                      minWidth: 24,
                      textAlign: "center",
                    }}
                  >
                    {documentsAlertCount}
                  </span>
                )}
              </Nav.Link>
            )
          );
        })}
        {isAdmin && (
          <>
            <Nav.Link
              href="#"
              className={
                location.pathname.startsWith("/transportistas") ||
                  location.pathname.startsWith("/vehiculos")
                  ? "active"
                  : ""
              }
              onClick={(e) => {
                e.preventDefault();
                setTransportesOpen((prev) => !prev);
              }}
            >
              <FaTruck /> {" "}Transportes {" "}
              {transportesOpen ? (
                <FaChevronDown style={{ float: "right", marginTop: 4 }} />
              ) : (
                <FaChevronRight style={{ float: "right", marginTop: 4 }} />
              )}
            </Nav.Link>
            {transportesOpen && (
              <div style={{ marginLeft: 24 }}>
                <Nav.Link
                  href="/transportistas"
                  className={
                    location.pathname.startsWith("/transportistas")
                      ? "active"
                      : ""
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/transportistas");
                    if (onClose) onClose();
                  }}
                >
                  <FaUser style={{ marginRight: 8 }} /> Transportistas
                </Nav.Link>
                <Nav.Link
                  href="/vehiculos"
                  className={
                    location.pathname.startsWith("/vehiculos")
                      ? "active"
                      : ""
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/vehiculos");
                    if (onClose) onClose();
                  }}
                >
                  <FaCar style={{ marginRight: 8 }} /> Vehículos
                </Nav.Link>
              </div>
            )}
          </>
        )}
      </Nav>
      <hr className="text-white" />
      <Nav className="flex-column">
        <Nav.Link
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleLogout();
            if (onClose) onClose();
          }}
          className="text-danger"
        >
          <FaSignOutAlt /> Cerrar Sesión
        </Nav.Link>
      </Nav>
    </div>
  );
};

export default Sidebar;
